<template>
  <div>
    <filter-slot
      :filter="[]"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-settings-holidays'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-settings-holidays"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="showFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="id"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(country)="row">
            {{ row.value }}
          </template>

          <template #cell(month)="row">
            {{ getMonthByNumber(row.value) }}
          </template>

          <template #cell(is_apply)="row">
            <b-badge
              :variant="row.value ? 'light-success' : 'light-danger'"
              class="badge-pill"
            >
              <span class="text-uppercase">
                {{ row.value == 1 ? $t("Yes") : $t("No") }}
              </span>
            </b-badge>
          </template>
          <template #cell(status)="row">
            <b-badge
              :variant="row.value ? 'light-success' : 'light-danger'"
              class="badge-pill"
            >
              <span class="text-uppercase">
                {{ row.value == 1 ? $t("Active") : $t("Inactive") }}
              </span>
            </b-badge>
          </template>
          <template #cell(created_by)="row">
            <span> {{ row.value | capitalize }} </span><br />
            <feather-icon
              icon="CalendarIcon"
              class="text-success"
              size="15"
              style="opacity: 0.7"
            />
            <span style="opacity: 0.7">
              {{ row.item.created_at | myGlobalDay }}
            </span>
          </template>
          <template #cell(actions)="row">
            <feather-icon
              icon="Edit2Icon"
              class="cursor-pointer mr-50 text-primary"
              size="15"
              @click="editHoliday(row.item)"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>

    <AddOrUpdateHoliday
      v-if="showAddOrUpdateHolidayModal"
      :action="'edit'"
      :holiday="holiday"
      @hidden="showAddOrUpdateHolidayModal = false"
      @updated="onUpdateHoliday"
    />
  </div>
</template>

<script>
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import Fields from "@/views/settings/views/payroll/components/holidays/data/holidays.fields.js";
import HolidayService from "@/views/settings/views/payroll/components/holidays/services/holiday.service.js";
import AddOrUpdateHoliday from "@/views/settings/views/payroll/components/holidays/ModalAddOrUpdateHoliday.vue";
import { getMonthByNumber } from "@/helpers/helpers.js";

export default {
  components: {
    FilterSlot,
    AddOrUpdateHoliday,
  },
  data() {
    return {
      fields: Fields,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      showAddOrUpdateHolidayModal: false,
      holiday: {},
    };
  },
  computed: {
    showFields() {
      return this.fields.filter((field) => field.visible);
    },
  },
  methods: {
    // helpers
    getMonthByNumber,

    async myProvider(ctx) {
      try {
        this.addPreloader();
        let order = 0;

        switch (ctx.sortBy) {
          case "country":
            order = 6;
            break;
          case "name":
            order = 2;
            break;
          case "month":
            order = 8;
            break;
          case "day":
            order = 9;
            break;
          case "is_apply":
            order = 3;
            break;
          case "status":
            order = 4;
            break;
          case "created_by":
            order = 7;
            break;
          default:
            order = 1;
            break;
        }

        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: order,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          from: null,
          to: null,
        };
        const { data } = await HolidayService.getHolidays(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        this.showToastError(error);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    onUpdateHoliday() {
      this.showAddOrUpdateHolidayModal = false;
      this.$refs["ref-table-settings-holidays"].refresh();
    },
    editHoliday(holiday) {
      this.showAddOrUpdateHolidayModal = true;
      this.holiday = holiday;
    },
  },
};
</script>

<style>
</style>